import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { isCollectionKimeraError } from '../utils/isCollectionKimeraError';

export const removeFromCollection = async (itemId: string) => {
    try {
        const response = await axios.delete(pathfinder('delete_collections_items'), { data: { item_ids: [itemId] } });

        return response.data;
    } catch (error) {
        if (!isCollectionKimeraError(error)) {
            logger.error(error as Error, {
                description: 'Failed to remove resource from collection',
                itemId,
            });
        }
        throw error;
    }
};
